import request from '../utils/fetch'
import { isObject, isArray } from 'lodash'
import qs from 'qs'
import { SIGNAL_CODE_KEY } from '../constants/propertyKeys'

const ENTRY = '/devices'

export const getDevices = (pageSize, page, sorted, filtered) => {
  const sort = {}
  if (sorted && sorted.length > 0) {
    sort[sorted[0].id] = sorted[0].desc ? -1 : 1
  }
  const filter = {}
  for (let index = 0; index < filtered.length; index++) {
    const { id, value } = filtered[index]
    let valueSended = value
    if (isObject(value) && !isArray(value)) {
      valueSended = value.value
    }
    if (valueSended!==undefined) filter[id] = valueSended
  }
  const tmp = qs.stringify({
    ...filter,
    $sort: sort,
    $skip: page * pageSize,
    $limit: pageSize
  })
  return request(`${ENTRY}?${tmp}`, { method: 'GET' })
}

export const deleteDevice = deviceId => {
  return request(`${ENTRY}/${deviceId}`, { method: 'DELETE' })
}

export const createDevice = data => {
  return request(ENTRY, {
    method: 'POST',
    body: JSON.stringify({
      productId: `SLN_${data[SIGNAL_CODE_KEY]}`,
      deviceTypeId:
        process.env.NODE_ENV !== 'production'
          ? '5c3425ea05cac80008664ffe'
          : '5c736283bb83c20006dd83b7',
      propertiesValue: {
        ...data,
        status:0
      }
    })
  })
}

export const createMultiDevices = data => {
  return request(ENTRY, {
    method: 'POST',
    body: JSON.stringify(
      data.map(item => ({
        productId: `SLN_${item[SIGNAL_CODE_KEY]}`,
        deviceTypeId:
          process.env.NODE_ENV !== 'production'
            ? '5c3425ea05cac80008664ffe'
            : '5c736283bb83c20006dd83b7',
        propertiesValue: {
            ...item,
            status:0
        }
      }))
    )
  })
}
